import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useListIntegrationsSpecsQuery } from '@frontend/api-integration-dashboard';
import { DashboardView } from '../../../../pages';
import { useIntegrationsDashboardShallowStore } from '../../../../store';

const DEFAULT_INTEGRATIONS_DATA = { integrationSpecs: [] };

const Dashboard = () => {
  const { data: integrationSpecsData, isFetching, isError } = useListIntegrationsSpecsQuery({ request: {} });
  const { setIsUserLoggingIn } = useIntegrationsDashboardShallowStore('setIsUserLoggingIn');

  const { integrationSpecs } = integrationSpecsData ?? DEFAULT_INTEGRATIONS_DATA;

  useEffect(() => {
    setIsUserLoggingIn(false);
  }, []);

  return <DashboardView integrations={integrationSpecs} isLoading={isFetching} isError={isError} />;
};

export const Route = createFileRoute('/_auth/dashboard/')({
  component: Dashboard,
});
